import React, { useMemo } from 'react';
import { BaseCol } from '@app/components/common/BaseCol/BaseCol';
import { ShopOutlined } from '@ant-design/icons';
import { useAppSelector } from '@app/hooks/reduxHooks';
import { FirmCard } from './statisticsCard/StatisticsCard/FirmCard';

export const FirmCards: React.FC = () => {
  const user = useAppSelector((state) => state.user.user);
  const FirmLabel = user?.AllowedFirms.find((obj) => obj.value === user?.DefualtFirmId)?.label || null;

  const statisticsCards = useMemo(() => {
    return (
      <>
        <BaseCol key={1} xs={24} md={24}>
          <FirmCard
            name={FirmLabel || ''}
            color={'success'}
            Icon={() => <ShopOutlined style={{ fontSize: '36px', color: '#08c' }} />}
          />
        </BaseCol>
      </>
    );
  }, [FirmLabel]);

  return <>{statisticsCards}</>;
};
